module.exports = __webpack_public_path__ + "static/img/3.b0ec5c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/detect/3.png
// module id = 28Ur
// module chunks = 13